var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.724976 10.9416C0.204142 10.4208 0.204142 9.57497 0.724976 9.05413L8.72498 1.05413C9.24581 0.533298 10.0916 0.533298 10.6125 1.05413C11.1333 1.57497 11.1333 2.4208 10.6125 2.94163L3.55414 9.99997L10.6083 17.0583C11.1291 17.5791 11.1291 18.425 10.6083 18.9458C10.0875 19.4666 9.24164 19.4666 8.72081 18.9458L0.720809 10.9458L0.724976 10.9416Z",
    fill: "#192BC2",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftChevron);
export default __webpack_public_path__ + "static/media/LeftChevron.35a0ed91286f716674bc2449be29acf0.svg";
export { ForwardRef as ReactComponent };